import type { Permission } from "@shared/types";

export function getCurrentRoles(): string[] {
  const devRole = localStorage.getItem("dev_role");
  if (devRole) return devRole.split(",").map((r) => r.trim());
  return ["admin"];
}

export function checkPermission(
  userRoles: string[],
  resource: string,
  action: "create" | "read" | "update" | "delete" | "*",
  permissions: Permission[],
): boolean {
  return permissions.some((perm) => {
    const roleMatch = userRoles.includes(perm.role);
    const resourceMatch = perm.resource === "*" || perm.resource === resource;
    const actionMatch = perm.action === "*" || perm.action === action;
    return roleMatch && resourceMatch && actionMatch;
  });
}

export function getEffectiveActions(
  userRoles: string[],
  resource: string,
  permissions: Permission[],
): Set<"create" | "read" | "update" | "delete"> {
  const actions: Set<"create" | "read" | "update" | "delete"> = new Set();
  const allActions: ("create" | "read" | "update" | "delete")[] = ["create", "read", "update", "delete"];

  for (const perm of permissions) {
    if (!userRoles.includes(perm.role)) continue;
    if (perm.resource !== "*" && perm.resource !== resource) continue;

    if (perm.action === "*") {
      allActions.forEach((a) => actions.add(a));
    } else {
      actions.add(perm.action);
    }
  }

  return actions;
}
